import React from 'react'
import { object } from 'prop-types'
import { Input } from 'antd'
import { FontSizeOutlined } from '@ant-design/icons'

import { Widget, useUpdate, useValidation } from './base/widget'
import { CommonFields } from './base/widgetCommonFields'
import { FormItem, styleIconValidation } from './base/styles'
import { useSelector } from 'react-redux'

export const TextWidget = React.memo((props) => {
	const { data } = props

	const update = useUpdate(props)
	const [valid, setValid] = useValidation(props)
	const contextAiEnabled = useSelector(
		(state) => state.editTemplate.data.config.contextAi
	)

	return (
		<Widget
			{...props}
			type={'Texto'}
			icon={<Icon $error={!valid} />}
			onValidate={setValid}
			formItems={
				<div>
					<CommonFields data={data} update={update} />
					<FormItem label="Placeholder">
						<Input
							onBlur={(e) => update({ placeholder: e.target.value })}
							defaultValue={data.placeholder}
							autoComplete="off"
						/>
					</FormItem>

					<FormItem label="Valor inicial">
						<Input
							onBlur={(e) => update({ initialValue: e.target.value })}
							defaultValue={data.initialValue}
							autoComplete="off"
						/>
					</FormItem>

					{contextAiEnabled && (
						<FormItem label="Prompt">
							<Input.TextArea
								onBlur={(e) => update({ prompt: e.target.value })}
								defaultValue={data.prompt}
								autoSize={{ minRows: 3, maxRows: 6 }}
							/>
						</FormItem>
					)}
				</div>
			}
			displayStyles={[
				{ value: 'plain', name: 'Plain' },
				{ value: 'uppercase', name: 'Uppercase' },
				{ value: 'lowercase', name: 'Lowercase' },
				{ value: 'sentence_case', name: 'Sentence case' },
			]}
		/>
	)
})

const Icon = styleIconValidation(FontSizeOutlined)

TextWidget.propTypes = {
	data: object,
}
